import React from 'react';
import { motion } from 'framer-motion';
import { config } from '../../config/jewelleryLandingConfig';

const Transformation = () => {
  return (
    <section className="py-24 bg-espresso text-ivory">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-5xl mb-6 text-champagne">Elevate Your Visual Identity</h2>
            <p className="text-lg font-light leading-relaxed text-ivory/80 mb-8">
              Standard product photography limits your customer's ability to visualize the piece. We take your basic references and produce high-end, editorial model visuals that convey luxury, scale, and exact styling.
            </p>
            <ul className="space-y-4 font-light text-ivory/80">
              <li className="flex items-start">
                <span className="text-mutedGold mr-4 mt-1">✦</span>
                No expensive studio or agency fees
              </li>
              <li className="flex items-start">
                <span className="text-mutedGold mr-4 mt-1">✦</span>
                Consistent lighting and premium styling
              </li>
              <li className="flex items-start">
                <span className="text-mutedGold mr-4 mt-1">✦</span>
                Perfect representation of metals and stones
              </li>
            </ul>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="relative h-[500px]"
          >
            <img 
              src={config.media.transformationImage.src} 
              alt={config.media.transformationImage.alt} 
              className="w-full h-full object-cover shadow-premium"
              loading="lazy"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Transformation;